/// <reference path="registerSectionBase.ts" />
module Meevo.Plugins.Register {
    "use strict";

    export class RegisterPaymentSectionBase extends Meevo.Plugins.Register.RegisterSectionBase {
        payment: Model.SalePayment;

        private isAddingPayment: boolean = false;

        public addBalanceAsPayment() {
            this.payment.amount = this.registerContext.getPaymentAmount();
            this.payment.taxAmount = this.registerContext.getTaxAmount();
        }

        validateAmount() {
            let paymentAmount = parseFloat(this.payment.amount.toString());
            return paymentAmount === 0 ? false : true;
        }

        public addPayment(reset: boolean = true, automaticChangeDue: boolean = true) {
            if (!this.validateAmount()) {
                return;
            }

            this.isAddingPayment = true;

            this.registerContext.addPayment(this.payment, automaticChangeDue).then(() => {
                if (reset) {
                    this.reset();
                    this.selectSectionPostAdd();
                }
            }).finally(() => this.isAddingPayment = false);
        }

        selectSectionPostAdd() {
            if (this.registerContext.isCreditMode || this.registerContext.shouldShowChangeOptions()) {
                this.registerContext.recalculateChangeDue();
                this.registerContext.selectSection(RegisterSectionTypeEnum.ChangeOptions);
            }
            // Only proceed if the selected section hasn't already been changed
            else if (this.sectionType === this.registerContext.selectedSection.sectionType) {
                this.registerContext.selectSection(RegisterSectionTypeEnum.PaymentOptions);
            }
        }

        public addPaymentDisabled(isValid: boolean = true) {
            return !isValid || (this.payment && this.payment.amount === 0 && !this.registerContext.hasChangeDueWithRefunds()) || this.isAddingPayment;
        }

        public addPaymentLabel() {
            return "LABEL_ADD_PAYMENT";
        }

        public disablePayment() {
            return this.payment && this.payment.amount === 0 && !this.registerContext.isCreditMode;
        }

        public paymentLineRemoved(paymentLine) {
        }
    }
}